import styled, { css, keyframes } from 'styled-components';
import { Palette } from 'config';
import { sizes } from './Upload';

export const Container = styled.div`
  ${({ size }) => {
    if (size === sizes.Big) {
      return css`
        width: 100%;
      `;
    }
  }}
  min-height: 100%;
`;

// export const UploadBtn = styled(Button)`
//   span {
//     text-transform: none;
//   }
// `;

export const PdfPreview = styled.div`
  width: 100%;
  height: 100%;
  color: ${Palette.PrimaryGray._400};
  background-color: ${Palette.White._000};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  border-radius: 4px;
`;

export const UploadWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Palette.Primary._000};
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 8px;
  ${({ size }) => {
    if (size === sizes.Normal) {
      return css`
        width: 112px;
        height: 112px;
      `;
    } else if (size === sizes.Big) {
      return css`
        width: 100%;
        height: 160px;
      `;
    } else if (size === sizes.Medium) {
      return css`
        width: 100%;
        height: 72px;
      `;
    }
  }}

  &:hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }

  ${({ isEmpty }) => {
    return isEmpty
      ? css`
          background: ${() => Palette.PrimaryGray._000};
        `
      : css`
          background: ${() => Palette.PrimaryGray._000};
          border: 1px solid ${() => Palette.PrimaryGray._000};
        `;
  }}
`;

export const DeleteBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 6px;
  background: #ffffff;
  border: none;
  border-radius: 0 4px 0 4px;
  outline: none;
  cursor: pointer;
  svg {
    fill: ${() => Palette.PrimaryGray._400};
  }
  &:hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }
  &:active,
  &:focus {
    border: 1px solid ${() => Palette.Primary._300};
    box-shadow: inset 0px 0px 0px 2px rgba(59, 137, 246, 0.16),
      inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  }
`;

export const Output = styled.div`
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  max-width: 144px;
  max-height: 144px;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  ${DeleteBtn} {
    position: absolute;
    top: 0;
    right: 0;
  }
  ${({ size }) => {
    if (size === sizes.Big) {
      return css`
        height: 100%;
        width: 100%;
      `;
    }
  }}
`;

export const ImageWrapper = styled.div`
  height: 80px;
  width: 80px;

  ${({ size }) => {
    if (size === sizes.Big) {
      return css`
        height: 100%;
        width: 100%;
      `;
    }
  }}

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    border-radius: 4px;
    height: 128px;
    width: 128px;
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div`
  > svg {
    animation: ${rotate} 2s linear infinite;
    fill: ${() => Palette.PrimaryGray._400};
  }
`;

export const ErrorWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-top: 8px;

  img {
    height: 16px;
    width: 16px;
  }
`;

export const ErrorText = styled.span`
  color: ${() => Palette.Red._700};
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  margin-left: 8px;
`;
